import React, { useContext, useEffect, useRef, useState } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import Form from "../../Helpers/Form/Form";
import { Offcanvas } from "react-bootstrap";
import FormHeader from "../../Helpers/Form/FormParts/FormHeader";
import trans, { isRTL } from "../../../utils";
import { Segmented } from "antd";
import POIsInf from "./Information/POIsInf";
import POIsContact from "./Contact/POIsContact";
import POIsExtra from "./Extra/POIsExtra";
import StepsOffcanvasFooter from "../../Helpers/Offcanvasfooter/StepsOffcanvasFooter";
import POIsLocation from "./Location/POIsLocation";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
	useAddPOIMutation,
	useEditPOIMutation,
	useGetSpecificPOIQuery,
} from "../../../Redux/service/POIS/POIs";
import { toast } from "react-toastify";
import Loader from "../../Helpers/Loader/Loader";
export default function POIsForm({ MapRefetch }) {
	const {
		form,
		isEditing,
		handleClose,
		currentPOIId,
		setReloadData,
		attachmentsId,
		setAttachmentsId,
	} = useContext(popupcontext);
	console.log("Isedit", isEditing);
	const steps = [
		{ label: trans("information"), value: "information" },
		{ label: trans("location setup"), value: "location setup" },
		{ label: trans("contact"), value: "contact" },
		{ label: trans("extra"), value: "extra" },
	];
	const [submitAttempt, setSubmitAttempt] = useState(false);
	const [poiAttachments, setPoiAttachments] = useState();
	const [activeOption, setActiveOption] = useState("information");
	const [AddPOI, { isLoading: addLoading }] = useAddPOIMutation();
	const [EditPOI, { isLoading: editLoading }] = useEditPOIMutation();
	const {
		data: Editvalues,
		refetch,
		isLoading: valuesLoading,
	} = useGetSpecificPOIQuery(currentPOIId, {
		skip: !currentPOIId,
	});
	let initialValues = {
		name: null,
		code: null,
		status: true,
		type: null,
		latitude: null,
		longitude: null,
		address: null,
		notes: null,
		geofenced: false,
		area: null,
		diameter: null,
		country: null,
		state: null,
		city: null,
		clientName: null,
		contactPerson: {
			name: null,
			phone: null,
			email: null,
			isCurrentUser: false,
		},
		workingHours: [],
		customAttributes: null,
		attachments: [],
		attachmentsToDelete: null,
		parentId: null,
		forms: [],
		contractorLogo: null,
		contractorLabel: null,
		customer1Logo: null,
		customer1Label: null,
		customer2Logo: null,
		customer2Label: null,
		consultantLogo: null,
		consultantLabel: null,
	};
	let validSchema = Yup.object({
		name: Yup.string()
			.required(trans("Name is required"))
			.min(3, trans("Name must be at least 3 characters"))
			.test(
				"not-empty-or-spaces",
				trans("Name cannot be just whitespace"),
				(value) => !!value && value.trim().length > 0
			),
		type: Yup.string().required(trans("Type is required")),
		notes: Yup.string()
			.optional()
			.nullable()
			.test(
				"not-whitespace-only",
				trans("Notes cannot be just whitespace"),
				(value) => {
					if (value === null || value === undefined || value === "")
						return true; // allow empty
					return value.trim().length > 0; // disallow only whitespace
				}
			),
		geofenced: Yup.boolean(),
		diameter: Yup.string().when("geofenced", {
			is: true,
			then: (schema) =>
				schema
					.required(trans("Distance is required"))
					.test(
						"min",
						trans("Minimum distance is 50m"),
						(value) => !value || Number(value) >= 50
					)
					.test(
						"max",
						trans("Maximum distance is 1000m"),
						(value) => !value || Number(value) <= 1000
					),
			otherwise: (schema) => schema.notRequired(),
		}),

		country: Yup.string().required(trans("Country is required")),
		state: Yup.string().required(trans("State is required")),
		city: Yup.string().required(trans("City is required")),
		clientName: Yup.string()
			.min(3, trans("Client Name minimum 3 characters"))
			.optional()
			.nullable(),
		latitude: Yup.number()
			.required(trans("Latitude is required"))
			.typeError(trans("Latitude must be a number"))
			.min(-90, trans("Latitude must be between -90 and 90"))
			.max(90, trans("Latitude must be between -90 and 90")),
		longitude: Yup.number()
			.required(trans("Longitude  is required"))
			.typeError(trans("Longitude must be a number"))
			.min(-180, trans("Longitude must be between -180 and 180"))
			.max(180, trans("Latitude must be between -180 and 180")),
		contactPerson: Yup.object()
			.shape({
				name: Yup.string()
					.nullable()
					.min(3, trans("Name must be at least 3 characters"))
					.test("not-empty", trans("Name cannot be just whitespace"), (val) => {
						if (!val) return true;
						return val.trim().length > 0;
					}),
				email: Yup.string()
					.matches(
						/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/,
						trans("Email must be a valid email address with a valid domain")
					)
					.email()
					.nullable(),
				phone: Yup.string()
					.nullable()
					.test(
						"not-empty",
						trans("Phone cannot be just whitespace"),
						(val) => {
							if (!val) return true;
							return val.trim().length > 0;
						}
					),
				isCurrentUser: Yup.boolean(),
			})
			.test(
				"all-or-none",
				trans("If any contact person field is filled, all must be provided"),
				function (value) {
					if (!value) return true;

					const { name, email, phone, isCurrentUser } = value;
					const anyFilled = name || email || phone;
					const allFilled =
						!!name?.toString().trim() &&
						!!email?.toString().trim() &&
						!!phone?.toString().trim();

					// If one is filled but not all → error
					if (anyFilled && !allFilled && !isCurrentUser) {
						return this.createError({
							message: trans(
								"All contact person fields are required if one is filled"
							),
						});
					}

					return true;
				}
			)
			.nullable(),
		parentId: Yup.number().when("type", {
			is: (type) => type === "zone" || type === "building",
			then: (schema) => schema.required(trans("This field is required")),
			otherwise: (schema) => schema.nullable(),
		}),
	});
	let addPOI = useFormik({
		initialValues,
		validationSchema: validSchema,
		onSubmit: async (val) => {
			const { name, email, phone, isCurrentUser } = val.contactPerson || {};

			const hasAnyContactValue =
				!!name?.toString().trim() ||
				!!email?.toString().trim() ||
				!!phone?.toString().trim();

			if (!hasAnyContactValue) {
				// All fields are empty → set to null
				val.contactPerson = null;
			} else {
				// Clean up empty strings if needed
				val.contactPerson = {
					name: name?.toString().trim() || null,
					email: email?.toString().trim() || null,
					phone: phone?.toString().trim() || null,
					isCurrentUser: isCurrentUser || null,
				};
			}
			try {
				if (isEditing) {
					delete val.createdAt;
					delete val.updatedAt;
					delete val.createdBy;
					delete val.updatedBy;
					delete val.createdById;
					delete val.updatedById;
					delete val.parent;
					delete val.id;
					if (val.geofenced === false) {
						delete val.area;
						delete val.diameter;
					}
					if (val.type === "project" && val.parentId) {
						delete val.parentId;
					}
					await EditPOI({
						id: currentPOIId,
						val: val,
					}).unwrap();
					refetch();
					handleClose("form");
					setActiveOption("information");
					setSubmitAttempt(false);
					setPoiAttachments([]);
					toast.success(trans("POI Is Edited Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
				} else {
					//delete val.attachmentsToDelete;
					console.log("isArray:", Array.isArray(val.forms));
					await AddPOI(val).unwrap();
					toast.success(trans("POI Is Added Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					addPOI.resetForm();
					MapRefetch();
					setActiveOption("information");
					handleClose("form");
					setSubmitAttempt(false);
				}
				setReloadData(true);
			} catch (error) {
				console.log(error);
				toast.error(`${error?.data?.message}`, {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		},
	});
	const handleSubmit = (e) => {
		e.preventDefault();
		setSubmitAttempt(true);
		addPOI.handleSubmit(e);
	};
	useEffect(() => {
		if (isEditing && Editvalues) {
			addPOI.setValues(Editvalues?.data);
		} else if (!isEditing) {
			addPOI.resetForm(); // Clear form when not editing
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isEditing, Editvalues]);
	useEffect(() => {
		if (attachmentsId && isEditing) {
			addPOI.setFieldValue("attachmentsToDelete", attachmentsId);
		}
	}, [attachmentsId, isEditing]);
	const ranOnce = useRef(false);

	useEffect(() => {
		if (!ranOnce.current && addPOI?.values?.attachments?.length > 0 && form) {
			setPoiAttachments(addPOI.values.attachments);
			ranOnce.current = true;
		}
	}, [addPOI?.values?.attachments, form]);
	console.log("LLLL", poiAttachments);
	useEffect(() => {
		if (form === false) {
			addPOI.resetForm();
			setActiveOption("information");
			ranOnce.current = false;
			setAttachmentsId([]);
		}
	}, [form]);
	console.log("IsEditing", isEditing);
	console.log("ActiveOption", activeOption);
	const step = steps?.findIndex((i) => i?.value === activeOption);
	const disableNext = () => {
		if (
			step === 0 &&
			(addPOI.values.name === null ||
				addPOI.values.type === null ||
				addPOI.errors.name ||
				addPOI.errors.notes)
		) {
			return true;
		} else if (
			step === 1 &&
			(addPOI.values.city === null ||
				addPOI.values.country === null ||
				addPOI.values.state === null ||
				addPOI.values.latitude === null ||
				addPOI.values.longitude === null ||
				(addPOI.values.geofenced && addPOI.values.diameter === null) ||
				addPOI.errors.diameter ||
				addPOI.errors.latitude ||
				addPOI.errors.longitude)
		) {
			return true;
		} else if (
			step === 2 &&
			(addPOI?.errors?.contactPerson || addPOI?.errors?.contactPerson?.email)
		) {
			return true;
		} else {
			return false;
		}
	};
	console.log("ADDPOI", addPOI);
	let disable = disableNext();
	return (
		<Form show={form}>
			<Offcanvas.Header>
				<FormHeader
					title={isEditing ? trans("Edit POI") : trans("Add new POI")}
					other={false}
				/>
			</Offcanvas.Header>
			<div className="H-line"></div>
			{editLoading || addLoading || valuesLoading ? (
				<Loader style={{ height: "100vh" }} />
			) : (
				<>
					<Segmented
						options={steps.map((i, index) => ({
							label: i.label,
							value: i.value,
							disabled: !isEditing && index > step + 1,
						}))}
						style={{ textTransform: "capitalize" }}
						onChange={(value) => {
							console.log("Value", value);
							if (!disable) setActiveOption(value);
							if (
								disable &&
								activeOption === "location setup" &&
								value === "information"
							) {
								setActiveOption("information");
							}
							if (value === "information" || activeOption === "information") {
								addPOI.setFieldTouched("name", true, true);
								addPOI.setFieldTouched("type", true, true);

								addPOI.validateField("name");
								addPOI.validateField("type");
							} else if (
								value === "location setup" ||
								activeOption === "location setup"
							) {
								addPOI.setFieldTouched("city", true, true);
								addPOI.setFieldTouched("country", true, true);
								addPOI.setFieldTouched("state", true, true);
								addPOI.setFieldTouched("latitude", true, true);
								addPOI.setFieldTouched("longitude", true, true);
								if (addPOI.values.geofenced) {
									addPOI.setFieldTouched("diameter", true, true);
								}

								addPOI.validateField("city");
								addPOI.validateField("country");
								addPOI.validateField("state");
								addPOI.validateField("latitude");
								addPOI.validateField("longitude");
								addPOI.validateField("diameter");
							}
						}}
						onClick={(value) => {
							if (value === "information" || activeOption === "information") {
								addPOI.setFieldTouched("name", true, true);
								addPOI.setFieldTouched("type", true, true);
								addPOI.validateField("name");
								addPOI.validateField("type");
							} else if (
								value === "location setup" ||
								activeOption === "location setup"
							) {
								addPOI.setFieldTouched("city", true, true);
								addPOI.setFieldTouched("country", true, true);
								addPOI.setFieldTouched("state", true, true);
								addPOI.setFieldTouched("latitude", true, true);
								addPOI.setFieldTouched("longitude", true, true);
								if (addPOI.values.geofenced) {
									addPOI.setFieldTouched("diameter", true, true);
								}
								addPOI.validateField("city");
								addPOI.validateField("country");
								addPOI.validateField("state");
								addPOI.validateField("latitude");
								addPOI.validateField("longitude");
								addPOI.validateField("diameter");
							}
						}}
						value={activeOption}
						size="large"
						block
					/>
					<Offcanvas.Body dir={isRTL ? "rtl" : "ltr"}>
						{activeOption === "information" && <POIsInf addPOI={addPOI} />}
						{activeOption === "location setup" && (
							<POIsLocation addPOI={addPOI} />
						)}
						{activeOption === "contact" && <POIsContact addPOI={addPOI} />}
						{activeOption === "extra" && (
							<POIsExtra addPOI={addPOI} poiAttachments={poiAttachments} />
						)}
					</Offcanvas.Body>
					<form onSubmit={handleSubmit}>
						<StepsOffcanvasFooter
							step={steps?.findIndex((i) => i?.value === activeOption)}
							totalsteps={steps?.length - 1}
							setActiveOption={setActiveOption}
							segment={steps}
							addData={addPOI}
							submitAttempt={submitAttempt}
							handleSubmit={handleSubmit}
							disableNext={disableNext}
						/>
					</form>
				</>
			)}
		</Form>
	);
}
